import { render, staticRenderFns } from "./Embedded.vue?vue&type=template&id=ffac4f70&scoped=true"
import script from "./Embedded.vue?vue&type=script&lang=js"
export * from "./Embedded.vue?vue&type=script&lang=js"
import style0 from "./Embedded.vue?vue&type=style&index=0&id=ffac4f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac4f70",
  null
  
)

export default component.exports